import { ACTIONS } from '@auth/permissions.js';
import { IS_APP, OHIVE_COLORS } from '@constants/global.js';
import { route } from '@router/index.js';
import { UIButton, UIDiv, UIText } from '@ui';

export default class PaywallView extends UIDiv {
  constructor({ accessControl, orgId, subscriptionError }) {
    super();
    this.accessControl = accessControl;
    this.orgId = orgId;
    this.subscriptionError = subscriptionError;
    this.setClass('flex items-center justify-center min-h-[400px] p-8');
    this.render();
  }

  getContentByErrorType() {
    const canManageBilling = this.accessControl.hasPermission(ACTIONS.BILLING);

    switch (this.subscriptionError) {
      case 'MAX_REACHED':
        return {
          heading: i18next.t('pages.projects.paywall.max_reached.heading'),
          description: i18next.t(
            'pages.projects.paywall.max_reached.description',
          ),
          buttonText: i18next.t(
            'pages.projects.paywall.max_reached.button_text',
          ),
          routePath: `/settings?tab=organization&org=${this.orgId}`,
          showButton: canManageBilling && !IS_APP(),
          adminMessage: canManageBilling
            ? i18next.t('pages.projects.paywall.max_reached.admin_message')
            : i18next.t('pages.projects.paywall.max_reached.no_access_message'),
        };

      case 'SUBSCRIPTION_REQUIRED':
      default:
        return {
          heading: i18next.t(
            'pages.projects.paywall.subscription_required.heading',
          ),
          description: i18next.t(
            'pages.projects.paywall.subscription_required.description',
          ),
          buttonText: i18next.t('pages.projects.paywall.cta_button'),
          routePath: `/settings?tab=organization&org=${this.orgId}&subTab=subscription`,
          showButton: canManageBilling && !IS_APP(),
          adminMessage: canManageBilling
            ? i18next.t('pages.projects.paywall.admin_message')
            : i18next.t('pages.projects.paywall.no_access_message'),
        };
    }
  }

  render() {
    const content = new UIDiv().setClass(
      'bg-white rounded-xl shadow-xl p-6 sm:p-8 max-w-lg mx-auto text-center border border-gray-100',
    );

    const contentData = this.getContentByErrorType();

    const heading = new UIText(contentData.heading).setClass(
      'text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4',
    );

    const description = new UIDiv(contentData.description).setClass(
      'text-gray-600 mb-6 leading-relaxed text-sm sm:text-base',
    );

    if (contentData.showButton) {
      const ctaButton = new UIButton(contentData.buttonText)
        .setClass(
          `w-full sm:w-auto px-6 py-3 bg-[${OHIVE_COLORS.primary}] text-white rounded-lg font-semibold hover:bg-[${OHIVE_COLORS.primary}]/90 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5`,
        )
        .onClick(() => {
          return route(contentData.routePath);
        });

      content.add(heading, description, ctaButton);
    } else {
      const message = new UIDiv().setClass(
        'bg-blue-50 border border-blue-200 rounded-xl p-4 text-blue-800 text-sm sm:text-base',
      );
      message.setInnerHTML(contentData.adminMessage);
      content.add(heading, description, message);
    }

    this.add(content);
  }
}
